// extracted by mini-css-extract-plugin
export default {"container":"winnersList_container__o9Pq+","loaderContainer":"winnersList_loaderContainer__Ppx0Y","winnerListWrapper":"winnersList_winnerListWrapper__Mm4I8"};